var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('Header'),_c('Hero',{attrs:{"step":"fahrt"}}),_c('FahrtAuswahl'),_c('ReservationFee'),_c('AnzahlReservierung'),_c('BergfahrtUhrzeit'),_c('TalfahrtUhrzeit'),_c('SubsetUhrzeit'),_c('Footer'),_c('SlideNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }